var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.634,
    height: 12.816,
    viewBox: "0 0 11.634 12.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2611",
    "data-name": "Group 2611",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_489",
    "data-name": "Line 489",
    x2: 10.53,
    transform: "translate(0.055 4.374)",
    fill: "none",
    stroke: "#f6c244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_490",
    "data-name": "Line 490",
    x2: 0.005,
    transform: "translate(7.941 6.682)",
    fill: "none",
    stroke: "#f6c244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_491",
    "data-name": "Line 491",
    x2: 0.005,
    transform: "translate(5.32 6.682)",
    fill: "none",
    stroke: "#f6c244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_492",
    "data-name": "Line 492",
    x2: 0.005,
    transform: "translate(2.693 6.682)",
    fill: "none",
    stroke: "#f6c244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_493",
    "data-name": "Line 493",
    x2: 0.005,
    transform: "translate(7.941 8.977)",
    fill: "none",
    stroke: "#f6c244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_494",
    "data-name": "Line 494",
    x2: 0.005,
    transform: "translate(5.32 8.977)",
    fill: "none",
    stroke: "#f6c244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_495",
    "data-name": "Line 495",
    x2: 0.005,
    transform: "translate(2.693 8.977)",
    fill: "none",
    stroke: "#f6c244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_496",
    "data-name": "Line 496",
    y2: 1.944,
    transform: "translate(7.706)",
    fill: "none",
    stroke: "#f6c244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_497",
    "data-name": "Line 497",
    y2: 1.944,
    transform: "translate(2.934)",
    fill: "none",
    stroke: "#f6c244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4193",
    "data-name": "Path 4193",
    d: "M7.821,1.579h-5A2.542,2.542,0,0,0,0,4.322V9.669a2.566,2.566,0,0,0,2.819,2.793h5a2.544,2.544,0,0,0,2.819-2.749V4.322A2.533,2.533,0,0,0,7.821,1.579Z",
    transform: "translate(0 -0.646)",
    fill: "none",
    stroke: "#f6c244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.ed098683033244c42d8d0a20d206198a.svg";
export { ForwardRef as ReactComponent };